import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './DiscountTimer.module.scss';

const DiscountTimer = ({ endDate, discountName, compact = false }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const end = new Date(endDate).getTime();
      const difference = end - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return { days, hours, minutes, seconds };
      } else {
        setIsExpired(true);
        return {};
      }
    };

    const updateTimer = () => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
    };

    // Оновлюємо відразу
    updateTimer();

    // Оновлюємо кожну секунду
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [endDate]);

  if (isExpired) {
    return null; // Не показуємо таймер після закінчення знижки
  }

  const formatTime = (time) => {
    return time.toString().padStart(2, '0');
  };

  return (
    <div className={`${styles.discountTimer} ${compact ? styles.compact : ''}`}>
      <div className={styles.timerText}>
        {!compact && discountName && (
          <span className={styles.discountName}>Знижка {discountName} </span>
        )}
        {compact ? 'до ' : 'діє: '}
        {timeLeft.days > 0 && (
          <span className={styles.timeUnit}>
            {timeLeft.days}д.{' '}
          </span>
        )}
        <span className={styles.timeUnit}>
          {formatTime(timeLeft.hours || 0)}:
          {formatTime(timeLeft.minutes || 0)}
          {!compact && `:${formatTime(timeLeft.seconds || 0)}`}
        </span>
      </div>
    </div>
  );
};

DiscountTimer.propTypes = {
  endDate: PropTypes.string.isRequired,
  discountName: PropTypes.string,
  compact: PropTypes.bool,
};

DiscountTimer.defaultProps = {
  discountName: 'Знижка',
};

export default DiscountTimer;